
function Footer() {
  return (
    <footer className="bg-dark py-4 text-light text-center">
      <p>High Educational srls - Ente di Formazione accreditato della Regione Siciliana CIR - DT1952 per la formazione superiore e continua.<br></br>
      P.IVA 01967170851 - REA: CL-111122 - Tel. 0934/683881 <br></br>© 2025 High Educational. Tutti i diritti riservati.</p>
    </footer>
  );
}

export default Footer;
